/* eslint-disable jsx-a11y/alt-text */
import React, { useState, useEffect, useContext } from 'react';
import { styled, alpha } from '@mui/material/styles'; // <--- เพิ่ม alpha
import MuiDrawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import { NavLink, useLocation } from 'react-router-dom';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import ImageListItem from '@mui/material/ImageListItem';
import AssignmentIcon from '@mui/icons-material/Assignment';
import RestoreIcon from '@mui/icons-material/Restore';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import {
  Hidden,
  Box,
  useMediaQuery,
  useTheme,
  Divider,
  Button,
} from '@mui/material'; // <--- เพิ่ม Divider, Button
// import MobileSidebar from './MobileSidebar'; // (ไม่ได้ใช้ในโค้ดนี้)
import inetlogo from '../../assets/images/inetlogo.png';
import ManualSpeedDial from '../ManualSpeedDial';

import { PassportAuth } from '../../contexts/AuthContext';
import LogoutIcon from '@mui/icons-material/Logout';
import LanguageIcon from '@mui/icons-material/Language';
import { useTranslation } from 'react-i18next';

const drawerWidth = 220;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
  }),
}));

export default function Sidebar({ open, setOpen, openMobile, onMobileClose }) {
  const { t } = useTranslation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  const toggleLanguage = () => {
    const newLang = lang === 'th' ? 'en' : 'th';
    i18n.changeLanguage(newLang);
  };
  const { handleSignout } = useContext(PassportAuth);

  const items = [
    {
      href: '/invoice-main',
      icon: AssignmentIcon,
      title: t('app.invoicePrepaid'),
      sub: [],
    },
    {
      href: '/waiting-for-payment',
      icon: AccessTimeIcon,
      title: t('app.pendingPayments'),
      sub: [],
    },
    {
      href: '/payment-history',
      icon: RestoreIcon,
      title: t('app.paymentHistory'),
      sub: [],
    },
  ];

  const location = useLocation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  useEffect(() => {
    if (isMobile) {
      setOpen(false);
    } else {
      setOpen(true);
    }
  }, [isMobile, setOpen]); 

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  // --- (NEW) ส่วนหัว Logo (สำหรับ Desktop) ---
  const desktopLogo = (
    <ListItem
      disablePadding
      sx={{
        display: 'flex',
        minHeight: 64, // <-- ความสูง
        px: 1.5,
      }}
    >
      <ListItemButton
        onClick={() => {
          if (open) handleDrawerClose();
          else handleDrawerOpen();
        }}
        sx={{
          minHeight: 48,
          justifyContent: open ? 'initial' : 'center',
          borderRadius: '12px', // <-- ขอบมน
        }}
      >
        <ImageListItem sx={{ maxWidth: open ? '40px' : '50px' }}>
          {' '}
          {/* <-- ปรับขนาด */}
          <img src={inetlogo} />
        </ImageListItem>
        <ListItemText sx={{ opacity: open ? 1 : 0, ml: open ? '15px' : 0 }}>
          <div className="text-sm font-semibold">Internet Thailand</div>{' '}
          {/* <-- ปรับ Font */}
          <div className="text-xs">Public Company Limited</div>{' '}
          {/* <-- ปรับ Font */}
        </ListItemText>
      </ListItemButton>
    </ListItem>
  );

  // --- (NEW) ส่วนหัว Logo (สำหรับ Mobile) ---
  const mobileLogo = (
    <Box sx={{ display: 'flex', alignItems: 'center', p: 2 }}>
      <ImageListItem sx={{ maxWidth: '60px', mr: 2 }}>
        <img src={inetlogo} alt="INET Logo" />
      </ImageListItem>
      <Box>
        <div className="text-sm font-extrabold">Internet Thailand</div>
        <div className="text-sm">Public Company Limited</div>
      </Box>
    </Box>
  );

  // --- (NEW) ปุ่ม Language/Logout (สำหรับ Desktop) ---
  const desktopControls = (
    <div className="md:hidden">
      <Box sx={{ p: 2, mt: 'auto' }}>
        <Button
          onClick={toggleLanguage}
          fullWidth
          startIcon={<LanguageIcon />}
          sx={{ mb: 1, justifyContent: 'flex-start', color: 'text.secondary' }}
        >
          {lang === 'th' ? 'TH' : 'EN'}
        </Button>
        <Button
          variant="outlined"
          color="error"
          fullWidth
          onClick={handleSignout}
          startIcon={<LogoutIcon />}
        >
          Logout
        </Button>
      </Box>
    </div>
  );

  // --- (NEW) ปุ่ม Language/Logout (สำหรับ Mobile) ---
  const mobileControls = (
    <div className="flex justify-end p-4 mt-auto">
      {' '}
      {/* <-- เพิ่ม mt-auto */}
      <Button onClick={toggleLanguage}>
        <LanguageIcon />
        {lang === 'th' ? 'TH' : 'EN'}
      </Button>
      <Button color="error" size="small" onClick={handleSignout}>
        <LogoutIcon />
      </Button>
    </div>
  );


  const renderMenuItems = (isDrawerOpen) => (
    <List sx={{ p: 1 }}>
      {items.map((item) => {
        const isActive = item.href === location.pathname;
        return (
          <NavLink key={item.title} to={item.href}>
            <ListItemButton
              sx={{
                height: 44,
                justifyContent: isDrawerOpen ? 'initial' : 'center',
                borderRadius: '12px',
                my: 0.5,
                px: 2.5,
                backgroundColor: isActive
                  ? alpha(theme.palette.primary.main, 0.1)
                  : 'inherit',
                color: isActive ? 'primary.main' : 'inherit',
                '&:hover': {
                  backgroundColor: alpha(theme.palette.primary.main, 0.05),
                },
              }}
            >
              <ListItemIcon
                sx={{
                  minWidth: 5,
                  mr: isDrawerOpen ? 2 : 'auto',
                  justifyContent: 'center',
                  color: isActive ? 'primary.main' : 'inherit',
                }}
              >
                <item.icon />
              </ListItemIcon>
              <ListItemText
                primary={item.title}
                sx={{ opacity: isDrawerOpen ? 1 : 0 }}
                primaryTypographyProps={{
                  fontWeight: 600,
                  fontSize: '0.95rem',
                }}
              />
            </ListItemButton>
          </NavLink>
        );
      })}
    </List>
  );

  return (
    <Box sx={{ display: 'flex' }}>
      <Hidden smDown>
        <Drawer variant="permanent" open={open}>
          {desktopLogo}

          <Divider sx={{ mx: 2 }} />

          {renderMenuItems(open)}

          <Box sx={{ flexGrow: 1 }} />

          <div className="mt-auto">
            <ManualSpeedDial />
          </div>

          {open && (
            <>
              <Divider sx={{ mx: 2 }} />
              {desktopControls}
            </>
          )}
        </Drawer>
      </Hidden>

      {/* --- 2. MOBILE SIDEBAR --- */}
      <Hidden smUp>
        <MuiDrawer
          anchor="left"
          open={openMobile}
          onClose={onMobileClose}
          ModalProps={{
            keepMounted: true,
          }}
          PaperProps={{
            sx: { width: drawerWidth }, // <--- ใช้ตัวแปร
          }}
        >
          {mobileLogo} {/* <--- ใช้ Logo Mobile */}
          <Divider /> {/* <--- เพิ่มเส้นคั่น */}
          {renderMenuItems(true)}{' '}
          {/* <--- ใช้ Function Render (Mobile open=true เสมอ) */}
          <ManualSpeedDial /> {/* (ปิดไว้ก่อน ถ้าไม่ใช้) */}
          <Box sx={{ flexGrow: 1 }} /> {/* <--- ตัวดันไปล่างสุด */}
          <Divider /> {/* <--- เพิ่มเส้นคั่น */}
          {mobileControls} {/* <--- ใช้ Controls Mobile */}
        </MuiDrawer>
      </Hidden>
    </Box>
  );
}
